export { default } from './SpeechToTextButton';
export type { SpeechToTextButtonProps } from './SpeechToTextButton';
